<template>
    <svg width="31" height="31" viewBox="0 0 31 31" fill="none" stroke="currentColor" stroke-width="1.45538"
        stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path
            d="M15.6293 2.71643L27.0004 7.26482C27.4426 7.4417 27.7963 7.97234 27.7963 8.43982V12.6345C27.7963 13.3294 27.2278 13.8979 26.5329 13.8979H3.79079C3.0959 13.8979 2.52734 13.3294 2.52734 12.6345V8.43982C2.52734 7.97234 2.88112 7.4417 3.32332 7.26482L14.6944 2.71643C14.9471 2.61536 15.3766 2.61536 15.6293 2.71643Z" />
        <path
            d="M27.7963 27.796H2.52734V24.0056C2.52734 23.3107 3.0959 22.7422 3.79079 22.7422H26.5329C27.2278 22.7422 27.7963 23.3107 27.7963 24.0056V27.796Z" />
        <path d="M5.05469 22.7421V13.8979" />
        <path d="M10.1094 22.7421V13.8979" />
        <path d="M15.1602 22.7421V13.8979" />
        <path d="M20.2148 22.7421V13.8979" />
        <path d="M25.2695 22.7421V13.8979" />
        <path d="M1.26172 27.7959H29.0576" />
        <path
            d="M17.056 8.8439C17.056 9.89058 16.2075 10.7391 15.1608 10.7391C14.1141 10.7391 13.2656 9.89058 13.2656 8.8439C13.2656 7.79723 14.1141 6.94873 15.1608 6.94873C16.2075 6.94873 17.056 7.79723 17.056 8.8439Z" />
    </svg>
</template>
